import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import Stepper from './Stepper'

const PartyComp = (props) => {
  let ages = []
  for (let i = 1; i < 16; i++) {
    ages.push(i)
  }

  return (
    <div>
      {props.partyComp.map((party, i) => {
        return (
          <div className='form-group' data-automated-test={`partyCompSelector_${party.key}`} key={i}>
            <div>
              <div>{party.text} <small>({party.subText || party.subtext})</small></div>
            </div>
            <div className={props.errorPartyComp ? 'has-error' : ''}>
              <Stepper
                count={party.count}
                min={party.limit[0]}
                max={party.limit[1]}
                onUpdate={(count) => props.onChange(i, count)}
              />
            </div>
          </div>
        )
      })}
      {props.withChildAges && props.childAges.length > 0 &&
        <React.Fragment>
          <h3 className='text-center block-xs'>How old are they?</h3>
          {props.childAges.map((input, childIndex) => {
            return (
              <div key={childIndex} className={classNames({
                'clear': childIndex % 2 === 0,
                'form-group col-xs-6': true,
                'has-error': props.childAges[childIndex].error && props.errorChildAges
              })}>
                <label htmlFor={`child${childIndex}`}>Child {childIndex + 1}</label>
                <select
                  id={`child${childIndex}`}
                  value={props.childAges[childIndex].value}
                  className='form-control'
                  onChange={(e) => props.updateChildAge(childIndex, e)}
                  aria-invalid={props.childAges[childIndex].error}
                  aria-describedby={`help${childIndex}`}>
                  <option disabled value=''>
                    Select
                  </option>
                  {ages.map((age) => {
                    return (
                      <option key={age} value={age}>
                        {age === 1 ? (
                          '1 years and under'
                        ) : (
                          `${age} years`
                        )}
                      </option>
                    )
                  })}
                </select>
                {(props.childAges[childIndex].error && props.errorChildAges) && <div id={`help${childIndex}`} className='help-block'>
                  <FormattedMessage id='common.pleaseSelect' />
                </div>}
              </div>
            )
          })}
        </React.Fragment>
      }
    </div>
  )
}

PartyComp.defaultProps = {
  childAges: []
}

PartyComp.propTypes = {
  childAges: PropTypes.array,
  errorChildAges: PropTypes.bool.isRequired,
  errorPartyComp: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  partyComp: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    key: PropTypes.string,
    limit: PropTypes.array,
    subText: PropTypes.string,
    text: PropTypes.string
  })).isRequired,
  updateChildAge: PropTypes.func.isRequired,
  withChildAges: PropTypes.bool.isRequired
}

export default PartyComp
